module.exports = __webpack_public_path__ + "static/media/profile.998f4a99.png";